import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: 'semibold',
    display: 'flex',
    lineHeight: 'tall',
    justifyContent: 'space-between',
    marginInlineEnd: '0',
    mb: '0',
  },
  sizes: {
    large: {
      fontSize: '2xl',
      lineHeight: '2rem',
      letterSpacing: 'widest',
    },
  },
  defaultProps: {
    size: 'default',
  },
};
